(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('LanguageIbqDeleteController',LanguageIbqDeleteController);

    LanguageIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'Language'];

    function LanguageIbqDeleteController($uibModalInstance, entity, Language) {
        var vm = this;

        vm.language = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Language.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
